import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import { failureMessage } from '../Notifications/notificationsSlice';

import {
	getLink,
	getLinkCompleted,
	getLinkFailed,
	getLinks,
	getLinksCompleted,
	getLinksFailed,
	createLink,
	createLinkCompleted,
	createLinkFailed
} from './linksSlice';

export const getLinkEpic = (action$) =>
	action$.pipe(
		ofType(getLink.type),
		mergeMap(async (action) => {
			try {
				const response = await axios.get(
					`${primaryApi()}/api/v1/links/${action.payload}`
				);

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getLinkCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getLinkFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export const getLinksEpic = (action$) =>
	action$.pipe(
		ofType(getLinks.type),
		mergeMap(async () => {
			try {
				const response = await axios.get(`${primaryApi()}/api/v1/links`);

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getLinksCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getLinksFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export const createLinkEpic = (action$) =>
	action$.pipe(
		ofType(createLink.type),
		mergeMap(async (action) => {
			try {
				const payload = action.payload;

				const response = await axios.post(
					`${primaryApi()}/api/v1/links`,
					payload
				);

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [createLinkCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(createLinkFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [getLinkEpic, getLinksEpic, createLinkEpic];
